const _ = require("lodash");
const TrainerCore = require("../TrainerCore");

// NOTE: Many of the functions below are also used in bookTest.js for academy book tests (noted below)

const getStars = function(result) {
	const {problems} = result;
	let part1Correct = 0;
	let part2Correct = 0;
	const isPart2 = i => {
		return (
			(problems.length === 16 && i >= 12) || (problems.length === 20 && i >= 15)
		);
	};

	_.forEach(problems, (p, i) => {
		if (p.outcome === "correct") {
			if (isPart2(i)) {
				part2Correct++;
			} else {
				part1Correct++;
			}
		}
	});

	let starData, minFor1Star;
	// "row" indices are part 2 correct answers
	// "column" indices are part 1 above minimum for 1 star
	// See https://docs.google.com/document/d/1GP66V5PwVITlKVIh3g1ROkmKr9qH9zxEP_GmGpZR9zk/edit#bookmark=id.c5vgcqacymdz
	// for more info on star cutoffs
	if (problems.length === 16) {
		minFor1Star = 9;
		starData = [
			[1, 1, 1, 1],
			[1, 1, 1, 2],
			[1, 2, 2, 2],
			[2, 2, 3, 3],
			[3, 3, 3, 3],
		];
	} else if (problems.length === 20) {
		minFor1Star = 11;
		starData = [
			[1, 1, 1, 1, 1],
			[1, 1, 1, 1, 2],
			[1, 1, 2, 2, 2],
			[2, 2, 2, 2, 3],
			[2, 2, 3, 3, 3],
			[3, 3, 3, 3, 3],
		];
	}

	if (part1Correct < minFor1Star) return 0;

	return starData[part2Correct][part1Correct - minFor1Star];
};

// Also used by bookTest.js
const getStarProgressInfo = function(result) {
	const currentProblemRange = result.showTestPart1Decision
		? TrainerCore.getProblemRangeForTestPart(result, 1)
		: TrainerCore.getCurrentProblemRangeForTest(result);
	const savedProblems = _.filter(
		result.problems,
		(p, i) => _.includes(currentProblemRange, i) && p.saved
	).length;
	const currentProblems = currentProblemRange.length;
	const seenProblems = TrainerCore.hasSeenTestPart2(result)
		? result.problems.length
		: TrainerCore.getProblemRangeForTestPart(result, 1).length;
	const correctProblems = _.filter(
		result.problems,
		p => p.outcome === "correct"
	).length;
	const fillAmount = result.isComplete
		? correctProblems / seenProblems
		: savedProblems / currentProblems;

	return {
		currentProblems,
		savedProblems,
		seenProblems,
		correctProblems,
		fillAmount,
	};
};

const isFinished = function(result) {
	const anyUnansweredProblems = _.some(result.problems, p => !p.outcome);
	return (
		result.testComplete ||
		result.isComplete ||
		!anyUnansweredProblems ||
		result.hasQuit
	);
};

// Also used by bookTest.js
const computeBackendProgress = function(result, defaultProgress) {
	return _.extend({}, defaultProgress, {
		problems: defaultProgress.problems.map((p, i) =>
			_.extend(p, {
				saved: result.problems[i].saved,
				savedOutcome: result.problems[i].savedOutcome,
				submitStatus: result.problems[i].submitStatus,
			})
		),
		hasSeenTestPart2: result.hasSeenTestPart2,
		hasSeenChapterCompleteCelebration: !!result.hasSeenChapterCompleteCelebration,
	});
};

const shouldIntervene = function(result) {
	return false;
};

// Also used by bookTest.js
const getFirstAvailableIndex = function(result) {
	return _.first(TrainerCore.getCurrentProblemRangeForTest(result));
};

// Also used by bookTest.js
const getLastAvailableIndex = function(result) {
	return _.last(TrainerCore.getCurrentProblemRangeForTest(result));
};

// Also used by bookTest.js
const getSetProgressInfo = function(result) {
	return {
		viewType: "test",
		data: {},
	};
};

// Also used by bookTest.js
const getPercentComplete = function(result) {
	const numSaved = result.problems.filter(p => p.saved).length;
	const total = result.problems.length;
	return numSaved / total;
};

// Also used by bookTest.js
const getSummaryProblemsSolvedText = function(result) {
	const seenProblems = TrainerCore.hasSeenTestPart2(result)
		? result.problems.length
		: TrainerCore.getProblemRangeForTestPart(result, 1).length;
	const correctProblems = _.filter(
		result.problems,
		p => p.outcome === "correct"
	).length;

	return `You answered ${correctProblems} out of ${seenProblems} correctly.`;
};

const settings = {
	saveAllProblems: true,
	allowBrowseOnSummary: true,
	updatePercentCompleteOnStateChange: true,
	starProgressType: "test",
	canSwitchSet: true,
	staticMaxStars: true,
};

module.exports = {
	shouldIntervene,
	computeBackendProgress,
	getFirstAvailableIndex,
	getLastAvailableIndex,
	getSetProgressInfo,
	getPercentComplete,
	getStarProgressInfo,
	isFinished,
	getStars,
	getSummaryProblemsSolvedText,
	settings,
};
